import {useGetKpisByTypes} from '@domain/kpis'
import {DataContentWrapper} from '@hconnect/common/containers'
import {CalculationTimeFrameType, KpiVisibilityFlag} from '@hconnect/common/types'
import {CardBox, CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {
  PlantStatusDailyKpis,
  PlantStatusCardHeader,
  PROCESS_ENGINEER_KPI_TYPES
} from '@widgets/kpis'
import moment from 'moment-timezone'
import {Link} from 'react-router'

type Props = {
  plantId: string
  plantStatusPageHref?: string
}

export const ProcessPlantStatusDailyKpisContainer: React.FC<Props> = ({
  plantId,
  plantStatusPageHref
}) => {
  const timezone = useUpmPlantTimezone(plantId)
  const startOfYesterday = moment.utc().tz(timezone).subtract(1, 'days').startOf('day')
  const endOfYesterday = startOfYesterday.clone().endOf('day')
  const {
    data: yesterdayKpis = [],
    isLoading: areYesterdayKpisLoading,
    isError: isYesterdayKpisError,
    isRefetching: isYesterdayKpisRefetching,
    refetch: refetchYesterdayKpis
  } = useGetKpisByTypes({
    plantId,
    kpiVisibilityFlag: KpiVisibilityFlag.ProcessEngineerEntryPoint,
    kpiTypes: PROCESS_ENGINEER_KPI_TYPES,
    timeFrame: {
      startDate: startOfYesterday.toISOString(),
      endDate: endOfYesterday.toISOString(),
      calculationTimeFrameType: CalculationTimeFrameType.Yesterday
    }
  })

  const cardContent = (
    <CardBox data-test-id="plant-status-kpis-card">
      <PlantStatusCardHeader />
      <DataContentWrapper
        showLoader={areYesterdayKpisLoading}
        isError={isYesterdayKpisError}
        isRefetching={isYesterdayKpisRefetching}
        data={yesterdayKpis}
        retryFunction={() => void refetchYesterdayKpis()}
        progressSx={{color: 'primary.main'}}
      >
        <PlantStatusDailyKpis kpiItems={yesterdayKpis} />
      </DataContentWrapper>
    </CardBox>
  )

  if (!plantStatusPageHref) {
    return cardContent
  }

  return (
    <CardLinkWrapper<typeof Link>
      to={plantStatusPageHref}
      component={Link}
      data-test-id="plant-status-kpis-card-link-to-performance-plant-status"
    >
      {cardContent}
    </CardLinkWrapper>
  )
}
